import React from 'react';
import PrelimDamagesComponent from "./PrelimDamagesComponent";
import PrelimDamagesComponentNOPSLRA from "./PrelimDamagesComponentNOPSLRA";
import ClassFloatAverages from "../../../components/ClassFloatAverages/classFloatAverages";

const removeRibbon = (aggregateDamages) => {
	if (!aggregateDamages) {
		return;
	}
	return aggregateDamages
		.filter(y => y.damageType !== 'APPLIED_INFLATION_RIBON')
		.filter(y => y.damageType !== 'COMPLETE_DAMAGES');
};

const removeRibbon1 = (classFloatValues) => {
	if (!classFloatValues) {
		return;
	}

	let data = []
	if (classFloatValues && classFloatValues.length > 0) {
		data.push(
			{ 'name': 'classPeriodAveSO', classFloatAverages: classFloatValues[0]['classPeriodAveSO'] },
			{ 'name': 'classPeriodAveSI', classFloatAverages: classFloatValues[0]['classPeriodAveSI'] },
			{ 'name': 'classPeriodAveIH', classFloatAverages: classFloatValues[0]['classPeriodAveIH'] },
			{ 'name': 'classPeriodAveFloat', classFloatAverages: classFloatValues[0]['classPeriodAveFloat'] },
		);
	} else {
		data.push(
			{ 'name': 'classPeriodAveSO', classFloatAverages: 0 },
			{ 'name': 'classPeriodAveSI', classFloatAverages: 0 },
			{ 'name': 'classPeriodAveIH', classFloatAverages: 0 },
			{ 'name': 'classPeriodAveFloat', classFloatAverages: 0 },
		);
	}
	classFloatValues = data;
	return classFloatValues
};

const PrelimDamagesContainer = (props) => {
	let isDandO = sessionStorage.getItem('DANDO');
	let data = removeRibbon(props.aggregateDamages);
	let data1 = removeRibbon(props.aggregateDamagesNOPSLRA);
	let data2 = removeRibbon1(props.classFloatAverages);
	return (
		<React.Fragment>
			{!props.caseRuleTypeId || props.caseRuleTypeId !== 3 ?
			<PrelimDamagesComponent aggregateDamages={data} isDandO={isDandO} />
			:
			""

			}
			{isDandO === "true" || props.caseRuleTypeId === 3 ? "" : <PrelimDamagesComponentNOPSLRA aggregateDamagesNOPSLRA={data1} />}
			<ClassFloatAverages classFloatAverages={data2} isDandO={isDandO}/>
		</React.Fragment>
	);

};


export default PrelimDamagesContainer;


// WEBPACK FOOTER //
// ./src/common/components/PrelimDamages/PrelimDamagesContainer.js